import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=51d6f7b6&scoped=true"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"
import style0 from "./Banks.vue?vue&type=style&index=0&id=51d6f7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6f7b6",
  null
  
)

export default component.exports